///<reference path="../../../../../../typings/index.d.ts"/>
///<reference path="../../docs-and-forms-api.service.ts"/>

module Meevo.Plugins.DocsAndForms {
    class ClientUdfs implements ng.IComponentController {

        static $inject = [
            'meevo.plugins.docsAndForms.DocsAndFormsApiService'
        ];

        public formBuilderModel: IFormBuilderModel;
    }

    angular.module('meevo.plugins.docsAndForms')
        .component('docsAndFormsClientUdfs', <angular.IComponentOptions>{
            templateUrl: 'app/plugins/clientIntakeForm/components/userDefinedFields/userDefinedFields.component.html',
            controller: ClientUdfs,
            controllerAs: '$ctrl',
            bindings: {
                formBuilderModel: '=',
                docsAndFormsModel: '=',
                disabled: '=?ngDisabled',
            }
        });
}
